<template>
  <main-wrapper>
    <map-nav mapWidth="100%" mapHeight="480px"></map-nav>
    <summary-nav></summary-nav>
    <nodelist-nav></nodelist-nav>
  </main-wrapper>
</template>

<script>
import MainWrapper from "common/components/MainWrapper.vue";
import MapNav from "./components/Map";
import SummaryNav from "./components/Summary";
import NodelistNav from "./components/Nodelist";
export default {
  name: 'home',
  components: {
    MainWrapper,
    MapNav,
    SummaryNav,
    NodelistNav,
  },
  created() {
    window.scrollTo(0,0);
  },
  mounted() {
    window.scrollTo(0,0);
    // 解决summary 中 饼图 tooltip 移动端难隐藏的问题
    document.documentElement.addEventListener('touchstart', this.EVENT_CAPTURE, true)
  },
  computed: {
    showChartTooltip() {
      return this.$store.state.home.showToolTip
    }
  },
  methods: {
    EVENT_CAPTURE(e) {
      if (e.target.tagName.toUpperCase() === 'CANVAS') {
        if (!this.showChartTooltip) {
          this.$store.commit('setShowToolTip', true)
        }
        return
      }
      if (this.showChartTooltip) {
        this.$store.commit('setShowToolTip', false)
      }
    }
  },
  beforeDestroy() {
    document.documentElement.removeEventListener('touchstart', this.EVENT_CAPTURE, true)
  }
}
</script>
